module.exports = __webpack_public_path__ + "static/img/jinshu.eb98d7b4.png";